import React from "react";
import { Link } from "react-router-dom";

const NjcReport3CTable = ({ cases, allCases, search, count }) => {
  // counts: missing values are 0, totals are over ALL rows (not only this page)
  const n = (v) => (typeof v === "number" && !isNaN(v) ? v : Number(v) || 0);
  const all = allCases || cases || [];
  const total = (key) => all.reduce((sum, item) => sum + n(item[key]), 0);
  return (
    <div className="table">
      <div className="section-cases-report">
        <span>Details of considered Judgement during the Quarter</span>
        <div className="no-print">
          <span className="specialaction">
            <Link
              to={`/reports/print/njc3/${search.eventtype}/${search.judgeid}/${search.divisionid}/${search.lastdate}`}
              target="_blank"
            >
              Print
            </Link>
          </span>
        </div>
      </div>
      <table className="case-table">
        <thead>
          <tr>
            <th className="col-title" rowSpan={2}>Case type</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th colSpan={2}>6</th>
            <th>7</th>
            <th>8</th>
          </tr>
          <tr>
            <th className="col-title">Cases brought forward from last Quarter</th>
            <th className="col-title">Cases assigned this Quarter</th>
            <th className="col-medium">Total Cases</th>
            <th className="col-title">Contested cases and judgement</th>
            <th className="col-title">Non-contested and struck out</th>
            <th className="col-title">Decisions on Interlocutory Proceedings - Contested</th>
            <th className="col-title">Decisions on Interlocutory Proceedings - Non-contested</th>
            <th className="col-title">Total number of cases disposed during the quarter</th>
            <th className="col-title">Cases pending at the end of the quarter</th>
          </tr>
        </thead>
        <tbody>
          {cases?.map((opt, index) => (
            <tr key={index}>
              <td>{opt.case_Type || "-"}</td>
              <td>{n(opt.previousQuarterScheduled)}</td>
              <td>{n(opt.currentQuarterUnconcluded)}</td>
              <td>{n(opt.totalCount)}</td>
              <td>{n(opt.casesWithMultipleClaimants)}</td>
              <td>{n(opt.casesWithStruckout)}</td>
              <td>{n(opt.interlocContested)}</td>
              <td>{n(opt.interlocNotContested)}</td>
              <td>{n(opt.casesTotalDispose)}</td>
              <td>{n(opt.pendingCases)}</td>
            </tr>
          ))}

          <tr style={{ fontWeight: "bold" }}>
            <td>Total</td>
            <td>
              {total("previousQuarterScheduled")}
            </td>
            <td>
              {total("currentQuarterUnconcluded")}
            </td>
            <td>{total("totalCount")}</td>
            <td>
              {total("casesWithMultipleClaimants")}
            </td>
            <td>
              {total("casesWithStruckout")}
            </td>
            <td>
              {total("interlocContested")}
            </td>
            <td>
              {total("interlocNotContested")}
            </td>
            <td>
              {total("casesTotalDispose")}
            </td>
            <td>{total("pendingCases")}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default NjcReport3CTable;
